/********************************************************************
 * Copyright (c) Certus Software, 2022.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import { Component, OnInit } from '@angular/core';
import {environment} from 'src/environments/environment';
import {Router} from '@angular/router';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'guide-banner',
  templateUrl: './guide-banner.component.html',
  styleUrls: ['./guide-banner.component.scss']
})
export class GuideBannerComponent implements OnInit {

  env = environment;
  constructor(
    public router: Router
  ) { }

  ngOnInit(): void {
  }

}
